import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Col } from 'reactstrap';
import { AssistanceUtilitiesWithNavigate } from '../../AssistanceUtilities';
import { useAuth } from '../../context/AuthContext';

interface AssistanceWithOpenExecutionsDashboardUtilitiesProps {
    kpiData: any;
}

const AssistanceWithOpenExecutionsDashboardUtilities: React.FC<AssistanceWithOpenExecutionsDashboardUtilitiesProps> = ({ kpiData }) => {

    const navigate = useNavigate();
    const assistanceUtilities = AssistanceUtilitiesWithNavigate(navigate);
    const { preferedView } = useAuth();

    return (
        <div className="kpiBoxes">
            <Col xl={12} lg={12} md={12} sm={12} xs={12} className="mb-3" >
                <div
                    style={{
                        backgroundColor: "#f6840e",
                        color: "white",
                        padding: "1rem",
                        borderRadius: "8px",
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "230px",
                    }}
                >
                    {/* Título */}
                    <div style={{ fontSize: "0.9rem", textAlign: "left" }}>
                        <FormattedMessage id="Screens.Dashboard.Assistance.With.Open.Executions" />
                    </div>

                    {/* Lista de Assistências */}
                    <div
                        style={{
                            width: "100%",
                            overflowY: "auto",
                            padding: "0.5rem",
                            paddingRight: "2rem",
                            borderRadius: "6px",
                            textAlign: "left",
                        }}
                    >

                        {kpiData?.assistancesInExecution && kpiData.assistancesInExecution.length > 0 ? (
                            kpiData.assistancesInExecution.map((assistencia: any, index: number) => (
                                <div
                                    key={index}
                                    style={{
                                        marginBottom: '0.5rem',
                                        padding: '0.5rem',
                                        borderBottom: '1px solid rgba(255, 255, 255, 0.5)',
                                        border: "1px solid white",
                                        backgroundColor: '#f6840e',
                                        borderRadius: '6px',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => assistanceUtilities.NavigateToAssistanceDetails(assistencia.assistanceId, preferedView)}
                                >

                                    <p style={{ margin: '0.2rem 0', fontWeight: 'bold' }}>
                                        Assistência:{' '}
                                        <span style={{ fontWeight: 'normal' }}>
                                            {assistencia.documentName ?? 'N/A'}
                                        </span>
                                    </p>
                                    <p style={{ margin: '0.2rem 0', fontWeight: 'bold' }}>
                                        Cliente:{' '}
                                        <span style={{ fontWeight: 'normal' }}>
                                            {assistencia.client ?? 'N/A'}
                                        </span>
                                    </p>
                                    <p style={{ margin: '0.2rem 0', fontWeight: 'bold' }}>
                                        Equipamento:{' '}
                                        <span style={{ fontWeight: 'normal' }}>
                                            {assistencia.equipment ?? 'N/A'}
                                        </span>
                                    </p>
                                    <p style={{ margin: '0.2rem 0', fontWeight: 'bold' }}>
                                        Técnico:{' '}
                                        <span style={{ fontWeight: 'normal' }}>
                                            {assistencia.technicianName ?? 'N/A'}
                                        </span>
                                    </p>
                                    <p style={{ margin: '0.2rem 0', fontWeight: 'bold' }}>
                                        Iniciou às:{' '}
                                        <span style={{ fontWeight: 'normal' }}>
                                            {assistencia.executionStart
                                                ? new Date(assistencia.executionStart).toLocaleString()
                                                : 'N/A'}
                                        </span>
                                    </p>
                                </div>
                            ))
                        ) : (
                            <p style={{ textAlign: 'center', color: '#ffffff' }}>
                                Não há assistências em execução.
                            </p>
                        )}
                    </div>
                </div>

            </Col>
        </div>
    );
};

export default AssistanceWithOpenExecutionsDashboardUtilities;